import React, { useEffect, useCallback, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import Form, { FormConsumer } from '@active/react-ui/Form';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import FormLabel from '@active/react-ui/FormLabel';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import Locale from '@active/react-utils/i18n/Locale';
import { useLocale } from '@active/react-utils/i18n';
import Input from '@active/react-ui/Input';
import pubSubInstance from '../../../../../../../shared/utils/pubSub';

const IdealPay = () => {
  const paymentForm = useRef();
  const {
    widgetNameSpace,
  } = useSelector(state => state.propsData);
  const { i18n } = useLocale();

  const accountHolderNameValidator = useCallback((value) => {
    const reg = /^[a-zA-Z0-9_‘,./-\s]{3,100}$/;
    if (!reg.test(value)) {
      return i18n('checkout.lib.components.payment.idealpay.valid.accountHolderName');
    }
    return '';
  }, [ i18n ]);

  const handleValidate = useCallback(() => {
    return new Promise((resolve) => {
      paymentForm.current.validateForm({ shouldTouchFields: true }).then((res) => {
        const formValid = isEmpty(res);
        resolve(formValid);
      });
    });
  }, [ paymentForm.current ]);

  const handleSubmit = useCallback(() => {
    const { values: { accountHolderName } } = paymentForm.current;
    return Promise.resolve({ status: true, accountHolderName, paymentMethodType: 'IDEAL' });
  }, [ paymentForm.current ]);

  useEffect(() => {
    pubSubInstance.subscribe(`${widgetNameSpace}-payment-item-validate`, handleValidate);
    pubSubInstance.subscribe(`${widgetNameSpace}-payment-item-submit`, handleSubmit);
    return () => {
      pubSubInstance.unsubscribe(`${widgetNameSpace}-payment-item-validate`, handleValidate);
      pubSubInstance.unsubscribe(`${widgetNameSpace}-payment-item-submit`, handleSubmit);
    };
  }, [ widgetNameSpace, handleValidate, handleSubmit ]);

  return (<div className="ideal-pay cui-mg-t-20">
    <Form
      customizeLayout
      trimInput>
      <Grid container={false} rowGap={0} colGap={0} >
        <GridItem span={12} spanXl={8}>
          <FormGroup name="accountHolderName" required>
            <FormLabel >
              <Locale id="checkout.lib.components.text.accountHolderName" />
            </FormLabel>
            <FormField
              maxLength="100"
              autoComplete="off"
              id="accountHolderName"
              validate={accountHolderNameValidator}
              as={Input}/>
          </FormGroup>
        </GridItem>
      </Grid>
      <FormConsumer>
        {
          ({ form }) => {
            paymentForm.current = form;
          }
        }
      </FormConsumer>
    </Form>
  </div>);
};

export default IdealPay;
